<template>
  <div class="bg-gray-300 px-4 py-8 text-gray-800 max-w-3xl mx-auto mt-3">
    <h1 class="text-3xl font-bold mb-6">Impressum</h1>

    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2">Angaben gemäß § 5 TMG</h2>
      <p>
        Thorsten Kasel<br />
        Hanielstr. 8 A<br />
        47119 Duisburg – Ruhrort<br />
        Deutschland
      </p>
    </section>

    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2">Kontakt</h2>
      <p>
        E-Mail: <a href="mailto:thorsten.kasel@web.de" class="text-blue-600 hover:underline">thosten.kasel@web.de</a>
        <!-- Telefonnummer nur falls du sie angeben willst -->
      </p>
    </section>

    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <p>
        Thorsten Kasel<br />
        Hanielstr. 8 A<br />
        47119 Duisburg – Ruhrort
      </p>
    </section>

    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2">Haftungsausschluss</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
        Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
      </p>
    </section>

    <section>
      <h2 class="text-xl font-semibold mb-2">Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.
        Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
        bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
</script>